import { z } from "zod";
import "./error-map";

export const createReturnItemSchema = z.object({
	productId: z.number().int().positive(),
	quantity: z.number().positive(),
	unitPrice: z.number().min(0),
	discountPercentage: z.number().min(0).max(100).optional().default(0),
	taxPercentage: z.number().min(0).max(100).optional().default(0),
	notes: z.string().optional(),
});

export const createReturnSchema = z.object({
	type: z.enum(["PURCHASE_RETURN", "SALE_RETURN"]),
	supplierId: z.number().int().positive().optional(),
	returnDate: z.string().optional(),
	status: z.string().optional(),
	paymentStatus: z.string().optional(),
	notes: z.string().optional(),
	discountAmount: z.number().min(0).optional(),
	shippingAmount: z.number().min(0).optional(),
	items: z.array(createReturnItemSchema).min(1, "validation.itemsRequired"),
	subtotal: z.number().min(0).optional(),
	totalAmount: z.number().min(0).optional(),
});

export type CreateReturnItemInput = z.infer<typeof createReturnItemSchema>;
export type CreateReturnInput = z.infer<typeof createReturnSchema>;
